import { useQuery, gql } from "@apollo/client"

export const BULK_OFFBOARDING_TERMINATIONS_QUERY = gql(`
  query BulkTerminationsQuery($bulkOffboardingId: ID!, $perPage: Int, $page: Int) {
    bulkOffboardingTerminations(bulkOffboardingId: $bulkOffboardingId, perPage: $perPage, page: $page) {
      collection {
        id
        proposedDate
        state
        mutualTermination
        additionalNotesForDepositTeam
        staffDepositNote
        serviceAgreementSignature
        additionalConsiderationAmount {
          subunit
          subunitToUnit
          currencyCode
        }
        additionalConsiderationAmountToBeConfirmed
        employment {
          id
          name
          startDate
          lastDayOn
          lastWorkingDay
          role
          serviceAgreementSignedEventDate
          salaryCurrencyCode
          severance {
            severanceType
            period
            periodDuration
            amount {
              subunit
              subunitToUnit
              currencyCode
            }
          }
          notice {
            periodDays
            noticeType
            period
            periodDuration
            gardenLeave
            entitlement
          }
          company {
            id
          }
        }
        engagement {
          id
          engagementType
          name
          termination {
            id
            proposedDate
          }
          payrollCurrencyCode
          teamMember {
            avatarUrl
          }
          isPayrollTeamMember
        }
      }
      metadata {
        totalCount
        totalPages
        currentPage
        limitValue
      }
    }
  }
`)

export const useBulkOffboardingTerminations = ({
  bulkOffboardingId,
  perPage = 10,
  page = 1,
}: {
  bulkOffboardingId: string
  perPage?: number
  page?: number
}) => {
  const { data, error, loading } = useQuery(BULK_OFFBOARDING_TERMINATIONS_QUERY, {
    variables: { bulkOffboardingId, perPage, page },
  })

  return { data, error, loading }
}
